module.exports = __webpack_public_path__ + "img/link-bg.0fe10105.png";